// src/App.js
import React from "react";
import Home from "./pages/Home";
import "./index.css";

export default function App() {
  return (
    <React.StrictMode>
      <Home />
    </React.StrictMode>
  );
}
